module.exports = __webpack_public_path__ + "img/whats-chance-img.60f4b1d0.svg";